import { type RefObject, useRef } from 'react';

import type { SlabTabProviderRefProps } from './SlabTabProvider';

interface ReturnTabViewProps<T extends string> {
  changeTab(name: T): void;
  TabViewRef: RefObject<SlabTabProviderRefProps<string>>;
}

export const useTabView = <T extends string>(): ReturnTabViewProps<T> => {
  const TabViewRef = useRef<SlabTabProviderRefProps<string>>(null);

  const changeTab = (name: T): void => TabViewRef.current?.changeTab(name);

  return {
    TabViewRef,
    changeTab,
  };
};
